import React from 'react';
import { Container } from '@charlietango/ui';
import { rem } from '../../styles/rem';

import Anchor from '../../components/Anchor/Anchor';
import { colors } from '../../styles/colors';
import LinkViewModel from '../../view-models/LinkViewModel';
import Navigation from './Navigation';
import HeaderBrand from './HeaderBrand';

type Props = {
  loggedIn?: boolean;
  logo?: LinkViewModel;
  navigationLinks?: LinkViewModel[];
  serviceMenuLinks?: LinkViewModel[];
};

function DesktopNavigation({
  loggedIn,
  serviceMenuLinks,
  navigationLinks,
  logo,
}: Props) {
  return (
    <header
      sx={{
        display: ['none', 'block'],
        background: colors.components.fixedTop.Background.Default,
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}
    >
      <Container
        sx={{
          maxWidth: ['none', 'none', rem(952)],
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: colors.components.fixedTop.Text.Default,
          pt: rem(12),
          pb: rem(12),
          px: [rem(20), rem(20), 0],
        }}
      >
        <Anchor prefetch {...logo} css={{ textDecoration: 'none' }}>
          <HeaderBrand />
        </Anchor>
        <div
          sx={{
            textAlign: 'right',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {navigationLinks && (
            <Navigation
              loggedIn={loggedIn}
              links={navigationLinks}
              serviceMenuLinks={serviceMenuLinks}
            />
          )}
        </div>
      </Container>
    </header>
  );
}

export default DesktopNavigation;
